{
  "Clear search": "Išvalyti iešką"
}